/**
 * Price list: one shape at a time, a row cap per table, and search across every shape.
 * Markup contract (templates/page.price-list.liquid):
 *   [data-pl-root] > section[data-pl-section][id] > ... tr[data-pl-row][data-name]
 *   a[data-pl-tab="<section id>"], button[data-pl-more] (data-more / data-less labels)
 *   input[data-pl-search], [data-pl-status], [data-pl-empty]
 * Without JS every table shows in full.
 */
const ROW_CAP = 12;
const root = document.querySelector('[data-pl-root]');
const input = document.querySelector('[data-pl-search]');
const status = document.querySelector('[data-pl-status]');
const empty = document.querySelector('[data-pl-empty]');
const tabs = [...document.querySelectorAll('[data-pl-tab]')];

if (root) {
  const sections = [...root.querySelectorAll('[data-pl-section]')];
  const expanded = new Set();
  const hashId = location.hash.slice(1);
  let active = sections.some((s) => s.id === hashId) ? hashId : sections[0]?.id;

  const query = () => (input?.value || '').trim().toLowerCase();

  const render = () => {
    const q = query();
    let matches = 0;
    sections.forEach((section) => {
      const rows = [...section.querySelectorAll('tr[data-pl-row]')];
      const more = section.querySelector('[data-pl-more]');
      const open = expanded.has(section.id);
      let hits = 0;
      rows.forEach((row, i) => {
        const hit = q ? row.dataset.name.includes(q) : open || i < ROW_CAP;
        row.hidden = !hit;
        if (q && hit) hits += 1;
      });
      matches += hits;
      section.hidden = q ? hits === 0 : section.id !== active;
      if (more) {
        more.hidden = Boolean(q);
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? more.dataset.less : more.dataset.more;
      }
    });
    tabs.forEach((tab) => {
      if (!q && tab.dataset.plTab === active) tab.setAttribute('aria-current', 'true');
      else tab.removeAttribute('aria-current');
    });
    if (empty) empty.hidden = !(q && matches === 0);
    if (status) {
      status.textContent = q
        ? (matches === 0 ? status.dataset.none : status.dataset.some.replace('{count}', matches))
        : '';
    }
  };

  const scrollToActive = () => {
    const section = document.getElementById(active);
    if (section && root.getBoundingClientRect().top < 0) section.scrollIntoView({ block: 'start' });
  };

  // Shape menu: the pill shows the chosen shape; picking one closes the menu.
  const menu = document.querySelector('[data-pl-menu]');
  const menuLabel = menu?.querySelector('[data-pl-menu-label]');

  const syncMenu = () => {
    const tab = tabs.find((t) => t.dataset.plTab === active);
    if (!menuLabel || !tab) return;
    const count = document.createElement('span');
    count.className = 'tabular-nums';
    count.textContent = tab.dataset.count;
    menuLabel.replaceChildren(`${tab.dataset.label} · `, count);
  };

  const activate = (id) => {
    active = id;
    if (input) input.value = '';
    render();
    syncMenu();
    if (menu) menu.open = false;
    history.replaceState(null, '', `#${active}`);
    scrollToActive();
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      activate(tab.dataset.plTab);
    });
  });

  // Close the menu on an outside click or Escape.
  document.addEventListener('click', (event) => {
    if (menu?.open && !menu.contains(event.target)) menu.open = false;
  });
  menu?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
  syncMenu();

  // Phone weight switcher: one weight column pair at a time, synced across every shape.
  root.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pl-weight]');
    if (!btn) return;
    root.dataset.w = btn.dataset.plWeight;
    root.querySelectorAll('[data-pl-weight]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.plWeight === root.dataset.w));
    });
  });

  root.addEventListener('click', (event) => {
    const more = event.target.closest('[data-pl-more]');
    if (!more) return;
    const id = more.getAttribute('aria-controls');
    if (expanded.has(id)) {
      expanded.delete(id);
      render();
      document.getElementById(id)?.scrollIntoView({ block: 'start' });
    } else {
      expanded.add(id);
      render();
    }
  });

  input?.addEventListener('input', render);
  render();
}
